import React, { FunctionComponent } from "react";

import { AlignItems, FlexWrap, Layout, SpacingSize } from "@multiweb/reactComponents";
import { bemClassNames, EMPTY_ARRAY } from "@multiweb/reactUtils";
import { Role } from "@multiweb/uiShared/Role";
import { ListHeaderAttribute } from "../ListHeaderAttribute";

export type ListHeaderComponentProps = {
    /** Unikátní klíč pro DataSource. */
    dataSourceKey: string;
    /** Obsahuje seřazené ikonové atributy k zobrazení. */
    iconDataSourceAttributeNames?: ReadonlyArray<string>;
    /** Obsahuje seřazené atributy s obsahem k zobrazení. */
    contentDataSourceAttributeNames?: ReadonlyArray<string>;
};

const classNames = bemClassNames("list-header-component");

export const ListHeaderComponent: FunctionComponent<ListHeaderComponentProps> = ({
    dataSourceKey,
    iconDataSourceAttributeNames = EMPTY_ARRAY as ReadonlyArray<string>,
    contentDataSourceAttributeNames = EMPTY_ARRAY as ReadonlyArray<string>,
}) => {
    // useMemo nemá cenu - attrNames se mění zároveň.
    const orderedAttributes = iconDataSourceAttributeNames
        .concat(contentDataSourceAttributeNames);
    const items = orderedAttributes?.map((attributeName, index) => (
        <ListHeaderAttribute key={`${attributeName}-${index}`} {...{ dataSourceKey, attributeName }} />
    ));

    return (
        <div className={classNames()} role={Role.rowGroup}>
            <div role={Role.row}>
                <Layout
                    flexWrap={FlexWrap.wrap}
                    alignItems={AlignItems.flexStart}
                    spacingSize={SpacingSize.xs}
                    spacingSizeLeft={SpacingSize.m}
                >
                    {items}
                </Layout>
            </div>
        </div>
    );
};
